import { Component } from '@angular/core';
import { OptionsListMulti, Row, TemplateItemEditorComponent, TemplateItemEditorModalComponent } from 'gung-common';

@Component({
  selector: 'lib-standard-template-item-editor',
  standalone: false,
  templateUrl: './standard-template-item-editor.component.html',
  styleUrl: './standard-template-item-editor.component.scss'
})
export class StandardTemplateItemEditorComponent extends TemplateItemEditorComponent {
  private rowUiIdCounter = 0;

  setTemplate(templateId: string) {
    super.setTemplate(templateId);

    for (const row of this.rows) {
      this.ensureRowUiState(row);
    }
  }

  buildAliasOptions(row: Row): OptionsListMulti[] {
    if (!this.aliasList) {
      return [];
    }

    return this.aliasList.map(alias => ({
      id: alias.id,
      name: alias.expression,
      badgeText: alias.name,
      selected: alias.expression === row.expression
    }));
  }

  getSelectedAliasId(row: Row): string {
    return this.aliasList?.find(a => a.expression === row.expression)?.id ?? '';
  }

  onSelectAlias(aliasId: string, row: Row) {
    const selectedAlias = this.aliasList.find(a => a.id === aliasId);
    if (!selectedAlias) {
      return;
    }

    row.expression = selectedAlias.expression;
    row.freeTextMode = false;
    this.unsaved(this.selectedTemplate.id);
  }

  override clickEdit(i: number, newRow?: Row, cloneItem?: boolean) {
    if (this.rows.length !== this.filteredRows.length) {
      i = this.rows.findIndex(r => r === this.filteredRows[i]);
    }
    const modalRef = this.modalService.open(TemplateItemEditorModalComponent, { ariaLabelledBy: 'modal-basic-title' });
    const item = { ...this.rows[i] };
    modalRef.componentInstance.item = JSON.stringify(newRow || item);
    modalRef.componentInstance.isActuator = this.isActuator;
    modalRef.componentInstance.cloneItem = cloneItem;
    modalRef.result.then(
      (result: string) => {
        if (result.localeCompare('Cance click') !== 0) {
          const row = JSON.parse(result) as Row;
          this.unsaved(this.templateId);
          if (newRow) {
            this.rows.splice(i + 1, 0, row);
            this.ensureRowUiState(this.rows[i + 1]);
          } else {
            this.rows[i] = row;
            this.ensureRowUiState(this.rows[i]);
          }
          if (this.rows.length !== this.filteredRows.length) {
            this.setSearch(this.searchString);
          }
        }
      },
      reason => {
        // console.log(`Dismissed ${reason}`); // ModalDismissReasons.BACKDROP_CLICK
      }
    );
  }

  private ensureRowUiState(row: Row): void {
    if (!row) {
      return;
    }

    if (!row.freeTextToggleId) {
      row.freeTextToggleId = `freeTextToggle-${this.rowUiIdCounter++}`;
    }

    if (row.aliasOptionsLoader === undefined) {
      row.aliasOptionsLoader = () => this.buildAliasOptions(row);
    }

    if (row.freeTextMode === undefined) {
      const hasMatchingAlias = !!row.expression && this.aliasList?.some(alias => alias.expression === row.expression);
      row.freeTextMode = !hasMatchingAlias;
    }
  }
}
